import React, { Component } from "react";
import { connect } from "react-redux";
import BattleLoginWall from "./battle/BattleLoginWall.js";
import OfflineBattleContainer from "./battle/OfflineBattleContainer";
import GameFrame from "./frame/GameFrame.js";
import BattleOverScreen from "./battle/BattleOverScreen.js";
//import HomeScreen from './b5-home/HomeScreen.js'
import CrewHome from "./b5-home/CrewHome";
import { b5LoadCrew } from "./battle/b5LoadCrew.js";
import RecordsScreen from "./b5-unlocks/RecordsScreen.js";
import OnboardingScreen from "./b5-onboarding/OnboardingScreen";
import { setGlobalValue } from "./redux-actions/global-actions";
import { getStartingGameArea } from "./getStartingGameArea";
import FullscreenState from './b5-home/FullscreenState'
import BrandingIntroScreen from './branding-intro/BrandingIntroScreen'
import {getSeenBrandingIntroFromLocalstorage, setSeenBrandingIntroInLocalstorage} from './branding-intro/branding-intro-localstorage-operations'

class App extends Component {
  constructor() {
    super();
    this.state = {
      needsToSeeIntro: !getSeenBrandingIntroFromLocalstorage(),
      isCrewLoaded: false
    };
  }

  componentWillMount() {

    //Check if we've seen the intro
    if (!this.state.needsToSeeIntro) {
      //If so, we're ready to launch the game!\
      this.launchGame();
    }
    //If not.. the screen will fire our `handleIntroSeen` method. No worries.
  }

  handleIntroSeen() {
    //This will be called by the BrandingIntroScreen after the user has seen it.

    //Set that we've seen it:
    setSeenBrandingIntroInLocalstorage();

    //Now launch the game
    this.setState({
      needsToSeeIntro: false
    }, () => {
      this.launchGame();
    })
  }

  launchGame() {
    //load the user's crew - then we can get started!
    b5LoadCrew((userStatus /* "newUser" | "returningUser"  */) => {
      //Get the starting gameArea for the app, now that b5 is loaded. (for dev, you can force overwrite right here)
      setGlobalValue({
        //gameArea: "b5-offline-battle-over" //Dev override
        gameArea: getStartingGameArea(userStatus)
      });

      this.setState({
        isCrewLoaded: true
      });
    });
  }

  render() {

    if (this.state.needsToSeeIntro) {
      return (
        <GameFrame>
          <BrandingIntroScreen onFinish={this.handleIntroSeen.bind(this)}/>
        </GameFrame>
      );
    }

    if (!this.state.isCrewLoaded) {
      //This could be the "THE DANGER CREW" screen, like MidiPixel

      //Do not show anything else until the Crew is loaded
      return (
        <GameFrame>
          <FullscreenState>
            <div style={{textAlign:"center"}}>Loading your crew...</div>
          </FullscreenState>
        </GameFrame>
      );
    }

    //Case: Home screen
    if (this.props.gameArea === "b5-onboarding-screen") {
      return (
        <GameFrame>
          <OnboardingScreen />
        </GameFrame>
      );
    }

    //Case: Home screen
    if (this.props.gameArea === "b5-home-screen") {
      return (
        <GameFrame>
          <CrewHome />
        </GameFrame>
      );
    }

    //Case: Records screen
    if (this.props.gameArea === "b5-records-screen") {
      return (
        <GameFrame>
          <RecordsScreen />
        </GameFrame>
      );
    }

    //Case A: Restart screen
    if (this.props.gameArea === "b5-offline-battle-over") {
      //TODO: change gameArea to this string after an offline battle!
      return (
        <GameFrame>
          <BattleOverScreen mode="offline" />
        </GameFrame>
      );
    }
    if (this.props.gameArea === "b5-online-battle-over") {
      return (
        <GameFrame>
          <BattleOverScreen mode="online" />
        </GameFrame>
      );
    }

    //Case B: Multiplayer mode
    if (this.props.isMultiplayerMode) {
      return (
        <GameFrame>
          <BattleLoginWall />
        </GameFrame>
      );
    }

    //Case C: Offline mode
    return (
      <GameFrame>
        <OfflineBattleContainer />
      </GameFrame>
    );
  }
}

export default connect((state, props) => {
  return {
    gameArea: state.global.gameArea,
    combatants: state.battle.combatants,
    teams: state.battle.teams,
    isMultiplayerMode: state.battle.isMultiplayerMode
  };
})(App);



// WEBPACK FOOTER //
// ./src/App.js